export const blockIconsActivitiesSportsGymnasticsNew = (
	<span className='material-symbols-outlined'>sports_gymnastics</span>
);
